import { render, staticRenderFns } from "./krasScenario.vue?vue&type=template&id=1c36e27a"
import script from "./krasScenario.vue?vue&type=script&lang=js"
export * from "./krasScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c36e27a')) {
      api.createRecord('1c36e27a', component.options)
    } else {
      api.reload('1c36e27a', component.options)
    }
    module.hot.accept("./krasScenario.vue?vue&type=template&id=1c36e27a", function () {
      api.rerender('1c36e27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/krasScenario.vue"
export default component.exports